<template>
  <div class="animated fadeIn" id="detailInsentifEngineer">
    <h3>{{ namePIC }}</h3>
    <br />
    <strong style="text-transform: capitalize;"> {{ type_ticket }} </strong>
    <br />
    Insentif : {{ prices | pointmoney }}
    <br />
    <template
      v-if="
        type_ticket === 'bongkar' ||
          typeTicket === 'survey' ||
          typeTicket === 'pasbar' ||
          typeTicket == 'relocation'
      "
    >
      <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>PIC</th>
            <th>Point</th>
            <th>Ticket Id</th>
            <th>Account Name</th>
            <th>Create</th>
            <th>Solved</th>
            <th>Close</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(detail, i) in detailTickets">
            <tr :key="i">
              <td>{{ i + 1 }}</td>
              <td>{{ detail.pic_name }}</td>
              <td align="center">{{ detail.poin }}</td>
              <td>
                <a
                  :href="
                    'https://isx.nusa.net.id/xtts.php?pid=detail&id=' +
                      detail.ticket_id
                  "
                  target="_blank"
                >
                  {{ detail.ticket_id }}
                </a>
              </td>
              <td>
                <a
                  :href="
                    'https://isx.nusa.net.id/customer.php?custId=' +
                      detail.CustId +
                      '&pid=profile&module=customer'
                  "
                  target="_blank"
                >
                  {{ detail.CustAccName }}
                </a>
              </td>
              <td>{{ detail.ticket_create }}</td>
              <td>{{ detail.solved_time }}</td>
              <td>{{ detail.closed_time }}</td>
              <td>{{ detail.problem }}</td>
            </tr>
          </template>
          <template v-if="detailTickets.length == 0">
            <tr class="bg-warning">
              <td colspan="8">
                No Ticket
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </template>
    <template v-else-if="type_ticket === 'survey win'">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th rowspan="2">No</th>
            <th rowspan="2">PIC</th>
            <th rowspan="2">Point</th>
            <th colspan="2" style="text-align: center;">Customer</th>
            <th colspan="3" style="text-align: center;">Survey</th>
            <th colspan="3" style="text-align: center;">Pasbar</th>
          </tr>
          <tr>
            <th>Service Id</th>
            <th>Name</th>
            <th>Ticket Id</th>
            <th>Solved Time</th>
            <th>Closed Time</th>
            <th>Ticket Id</th>
            <th>Solved Time</th>
            <th>Closed Time</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(detail, i) in detailTickets">
            <tr :key="i">
              <td>{{ i + 1 }}</td>
              <td>{{ detail.picName }}</td>
              <td align="center">{{ detail.poin }}</td>
              <td>
                <a
                  v-if="detail.CustServId"
                  :href="
                    'https://isx.nusa.net.id/v2/customer/service/' +
                      detail.CustServId +
                      '/detail'
                  "
                  target="_blank"
                >
                  {{ detail.CustServId }}
                </a>
              </td>
              <td>
                <a
                  :href="
                    'https://isx.nusa.net.id/customer.php?custId=' +
                      detail.CustId +
                      '&pid=profile&module=customer'
                  "
                  target="_blank"
                >
                  {{ detail.CustAccName }}
                </a>
              </td>
              <td>
                <a
                  :href="
                    'https://isx.nusa.net.id/xtts.php?pid=detail&id=' +
                      detail.TtsId
                  "
                  target="_blank"
                >
                  {{ detail.TtsId }}
                </a>
              </td>
              <td>
                {{ detail.solved_time }}
              </td>
              <td>
                {{ detail.close_time }}
              </td>
              <td :class="detail.ticket_type == 'reloc' ? 'bg-reloc' : ''">
                <a
                  :href="
                    'https://isx.nusa.net.id/xtts.php?pid=detail&id=' +
                      detail.pasbar_ticket_id
                  "
                  target="_blank"
                >
                  {{ detail.pasbar_ticket_id }}
                </a>
              </td>
              <td :class="detail.ticket_type == 'reloc' ? 'bg-reloc' : ''">
                {{ detail.pasbar_solved_time }}
              </td>
              <td :class="detail.ticket_type == 'reloc' ? 'bg-reloc' : ''">
                {{ detail.pasbar_closed_time }}
              </td>
            </tr>
          </template>
          <template v-if="detailTickets.length == 0">
            <tr class="bg-warning">
              <td colspan="5">
                No Ticket
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <span class="dot" v-bind:style="{ background: 'grey' }"></span> &nbsp;
      Ticket Reloc <br />
      <span
        class="dot"
        v-bind:style="{ background: 'white', border: '1px solid' }"
      ></span>
      &nbsp; Ticket Pasbar
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      namePIC: "",
      detailTickets: [],
      type_ticket: "",
      prices: 0
    };
  },
  created() {
    this.typedetail = this.typeTicket;
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    typeTicket: {
      type: String,
      default: ""
    },
    detailTicket: {
      type: Array,
      default: () => []
    },
    price: {
      type: Number,
      default: 0
    }
  },
  watch: {
    name() {
      this.namePIC = this.name;
    },
    detailTicket() {
      this.detailTickets = this.detailTicket;
    },
    typeTicket() {
      this.type_ticket = this.typeTicket;
    },
    price() {
      this.prices = this.price;
    }
  },
  created() {
    this.namePIC = this.name;
    this.detailTickets = this.detailTicket;
    this.type_ticket = this.typeTicket;
    this.prices = this.price;
  }
};
</script>
<style scoped>
.bg-reloc {
  background-color: grey;
  color: white;
}

.dot {
  height: 15px;
  width: 15px;
  background-color: #bbb;
  border-radius: 25%;
  display: inline-block;
}
</style>
